import classNames from 'classnames';
import * as React from 'react';
import { useWrapDetection } from '~/Utils/Hooks/useWrapDetection';

export interface LinkListSectionHeaderWithWrapDetectionProps {
    className: string;
    wrappedClassName: string;
}

export const LinkListSectionHeaderWithWrapDetection: React.FC<
    React.PropsWithChildren<LinkListSectionHeaderWithWrapDetectionProps>
> = props => {
    const { children, className, wrappedClassName } = props;

    const headerRef = React.useRef<HTMLDivElement>(null);
    const headerWrapped = useWrapDetection(headerRef);

    return (
        <div className={classNames(headerWrapped && wrappedClassName, className)} ref={headerRef}>
            {children}
        </div>
    );
};
